import { HELP_CENTER_ROUTE_PATHS as ACTION_CONFIGS_PATHS } from './action-configs/config';
import { CONTENT_ROUTE_PATHS } from './content/config';
import { HELP_CENTER_ROUTE_PATHS as KNOWN_ISSUES_PATHS } from './known-issues/config';
import { HELP_CENTER_ROUTE_PATHS as QUICK_ACTIONS_PATHS } from './quick-actions/config';
import { HELP_CENTER_ROUTE_PATHS as WORKFLOWS_PATHS } from './workflows/config';

export const HELP_CENTER_ROUTE_PATHS = {
  ...ACTION_CONFIGS_PATHS,
  ...WORKFLOWS_PATHS,
  ...CONTENT_ROUTE_PATHS,
  ...QUICK_ACTIONS_PATHS,
  ...KNOWN_ISSUES_PATHS,
};
